import React from 'react';
import classNames from 'clsx';
import { DropdownIcon } from '../assets/DropdownIcon';
import { MenuParts } from '../../../constants';
import classes from './style/MenuItem.module.scss';

export interface IMenuItemDropdownIconProps {
  chevronButtonRef: React.RefObject<HTMLButtonElement>;
  onClick: () => void;
  isOpen: boolean;
  hasSubItems: boolean;
  hasContainer: boolean;
  hasLink: boolean;
  isDropdownIconOpen: boolean;
  className?: string;
  ariaLabel?: string;
  srOnly: boolean;
  submenuToggleId?: string;
}

export const MenuItemDropdownIcon: React.FC<IMenuItemDropdownIconProps> = ({
  chevronButtonRef,
  onClick,
  isOpen,
  hasSubItems,
  hasContainer,
  hasLink,
  ariaLabel,
  isDropdownIconOpen,
  className,
  srOnly,
  submenuToggleId,
}) => {
  const button = (
    <button
      aria-label={ariaLabel}
      ref={chevronButtonRef}
      className={classNames(
        classes.dropdownToggleButton,
        !hasSubItems && !hasContainer && classes.noDropdownItems,
        !hasLink && classes.coverAllSpace,
        className,
      )}
      onClick={e => {
        if (hasLink) {
          e.stopPropagation();
        }
        onClick();
      }}
      aria-expanded={isOpen}
      {...(!srOnly && { 'data-part': MenuParts.DropdownButton })}
    >
      <DropdownIcon
        data-part={MenuParts.DropdownIcon}
        data-open={isDropdownIconOpen ? 'true' : undefined}
        className={classes.dropdownIcon}
      />
    </button>
  );

  return submenuToggleId ? (
    <span className={classes.submenuToggleWrapper}>
      <label
        htmlFor={submenuToggleId}
        className={classes.submenuToggleLabel}
        data-submenu-toggle-label=""
        aria-hidden="true"
      />
      {button}
    </span>
  ) : (
    button
  );
};
